import React, { Component } from 'react';
import { Col, Card, CardBody, Media, Alert } from "reactstrap";

class MiniWidgets extends Component {
    
    constructor(props) {
        super(props);
        this.state={
            error: false,
            errorMessage: "",
            data: this.props.statsdata,
            iconsrc: ["ri-book-2-fill", "ri-women-fill", "ri-men-fill", "ri-building-fill", "ri-home-gear-fill", "ri-lock-fill", "ri-map-pin-3-fill"]
        }
    }
    
    render() {
        return (
            <React.Fragment>
                { this.props.statsdata && this.props.statsdata.length > 1 ? 
                    this.props.statsdata?.map((report, key) =>
                                    <Col key={key} md={4}>
                                        <Card>
                                            <CardBody>
                                                <Media>
                                                    <Media body className="overflow-hidden">
                                                        <p className="text-truncate font-size-14 mb-2">{report.description}</p>
                                                        <h4 className="mb-0">{report.value}</h4>
                                                    </Media>
                                                    <div className="text-primary">
                                                        <i className={this.state.iconsrc[key] + " font-size-24"}></i>
                                                    </div>
                                                </Media>
                                            </CardBody>

                                            <CardBody className="border-top py-3">
                                                <div className="text-truncate">
                                                    <span className="badge badge-soft-success font-size-11 mr-1"><i className="mdi mdi-menu-up"> </i> {report.created}</span>
                                                    <span className="text-muted ml-2">{report.info}</span>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                    )
                    :
                    ""
                }
            </React.Fragment>
        );
    }

}

export default MiniWidgets;